import ArrowsArrowLeftSFill from './arrows-arrow-left-s-fill.component.js'

export * from './arrows-arrow-left-s-fill.component.js'
export default ArrowsArrowLeftSFill

ArrowsArrowLeftSFill.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-left-s-fill': ArrowsArrowLeftSFill
  }
}
